import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Button, Form, Segment, Message, Dropdown } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { 
  SG_GET_ORGANIZATION_SELECT,
  SG_COPY_DEBRIEF_PDF_GLOBAL_TO_ORG_TEMPLATE, 
  SG_GET_DEBRIEF_PDF_GLOBAL_TEMPLATES,
COPY_DEBRIEF_PDF_GLOBAL_TO_ORG_TEMPLATE } from "constants/actions";

const CopyGlobalToOrgTemplate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [globalTemplateId, setGlobalTemplateId] = useState("");
  const [orgId, setOrgId] = useState("");
  const [orgTemplateName, setOrgTemplateName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Assume global templates are loaded in state.debrief_pdf_report.global_templates


    const { globalTemplates, copied_template } = useSelector(
      (state) => ({
        globalTemplates: state.debrief_pdf_report.global_templates,
        copied_template: state.debrief_pdf_report.copied_template,
      }),
      shallowEqual
    );
  const organizationOptions = useSelector(
    state => state.organizations?.organization_select?.map((org) => ({
      key: org.id,
      value: org.id,
      text: `${org.id} - ${org.name}`,
    })) || []
  );

useEffect(() => {
    dispatch({ type: SG_GET_ORGANIZATION_SELECT });
  }, [dispatch]);

  useEffect(() => {
    dispatch({ type: SG_GET_DEBRIEF_PDF_GLOBAL_TEMPLATES, payload: 'global_template=true' });
  }, [dispatch]);

useEffect(() => {
    if (copied_template) {
      setLoading(false);
      dispatch({type: COPY_DEBRIEF_PDF_GLOBAL_TO_ORG_TEMPLATE, payload: null}); // Reset copied_template
      setSuccess("Template copied successfully.");
      setTimeout(() => navigate("/app/pdf-reports/"), 1200);
    }
  }, [copied_template, navigate, dispatch]);

  const handleSubmit = () => {
    setLoading(true);
    setError("");
    setSuccess("");
    dispatch({
      type: SG_COPY_DEBRIEF_PDF_GLOBAL_TO_ORG_TEMPLATE,
      payload: {
        global_template_id: globalTemplateId,
        target_organization_id: orgId,
        org_template_name: orgTemplateName,
      },
    });
  };

  return (
    <>
      <Button icon="arrow left" content="Back" onClick={() => navigate("/app/pdf-reports/")} style={{ marginBottom: 16 }} />
      <Segment padded="very">
        <Form loading={loading} onSubmit={handleSubmit} autoComplete="off">
        <Form.Field required>
          <label>Global Template</label>
          <Dropdown
            placeholder="Select Global Template"
            fluid
            search
            selection
            options={(globalTemplates || []).map(t => ({
              key: t.id,
              value: t.id,
              text: `${t.global_template_name || t.report_name || t.id}`,
            }))}
            value={globalTemplateId}
            onChange={(e, { value }) => setGlobalTemplateId(value)}
          />
        </Form.Field>
        <Form.Field required>
          <label>Organization</label>
          <Dropdown
            placeholder="Select Organization"
            fluid
            search
            selection
            options={organizationOptions}
            value={orgId}
            onChange={(e, { value }) => setOrgId(value)}
          />
        </Form.Field>
        <Form.Input
          label="Org Template Name (optional)"
          placeholder="Enter a name for the new org template"
          value={orgTemplateName}
          onChange={e => setOrgTemplateName(e.target.value)}
        />
        {error && <Message negative>{error}</Message>}
        {success && <Message positive>{success}</Message>}
  <Button primary type="submit" disabled={loading || !globalTemplateId || !orgId}>
          Copy to Org
        </Button>
        <Button type="button" onClick={() => navigate("/app/pdf-reports/templates/")}>Cancel</Button>
        </Form>
      </Segment>
    </>
  );
};

export default CopyGlobalToOrgTemplate;
